import React, {Component} from 'react';
import {Link} from "react-router-dom";
import FirstLevelItem from "../common/FirstLevelItem";
import {Col, Row} from "reactstrap";
import {Modal} from "antd";
import DownloadRequestModal from '../components/Table/DownloadRequestModal';
import UnderConstruction from "../common/UnderConstruction";

class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: "homePage",
            iconVisible: true,
            activeMenu: null,
            downloadRequestModal: false,

        };
        this.onChangeSelected = this.onChangeSelected.bind(this);
        this.toggleSidebar = this.toggleSidebar.bind(this);
        this.RightExists = this.RightExists.bind(this);
        this.showModal = this.showModal.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    RightExists(searchItem) {
        let exists = false;
        const authorities = this.props.authorities;
        for (const authority of authorities) {
            if (authority.authority.includes(searchItem)) {
                exists = true;
            }
        }
        return exists;
    }
    handleLiClick = () => {

        window.scrollTo({
            top: document.body.scrollHeight,
            left: 100,
            behavior: "smooth",
        });
    };
    onChangeSelected = (menuName) => {
        this.setState({ activeMenu: menuName });
        {menuName == "agendaOps" ? this.handleLiClick() :"" }
    };

    onChangeSelected(selected, activeMenu, event) {
        this.setState({selected, activeMenu});
    }
    openDownloadRequestModal = () => {
        this.setState({ downloadRequestModal: true });
    };

    closeDownloadRequestModal = () => {
        this.setState({ downloadRequestModal: false });
    };

    async toggleSidebar() {
        document.body.classList.toggle('sidebar-mini');
        this.props.setOffsetWidth(document.getElementById('sidebarModeButton').children[0].offsetWidth);
        this.state.iconVisible ? await this.setState({iconVisible: false}) : await this.setState({iconVisible: true});
    }

    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleCancel = () => {
        this.setState({
            visible: false,
        });
    };

    render() {
        const selected = this.state.selected;
        return (
            <div className="sidebar">
                <div className="logo" id="sidebar" style={{margin: '0', padding: '4px 0 0 0'}}>
                    {!this.state.iconVisible &&
                        <Row style={{padding: '0', margin: '0 0 0 10px'}}>
                            <a href="/" className="simple-text logo-mini">
                                <img style={{padding: '0', margin: '0'}} className="simple-text logo-mini"
                                     src={process.env.REACT_APP_CONTEXT_NAME + "/image/img.png"}/>
                            </a>
                        </Row>}
                    {this.state.iconVisible &&
                        <Row style={{padding: '0', margin: '0'}}>
                            <Col xs='4'>
                                <img style={{padding: '0', margin: '0'}} className=" simple-text logo-normal"
                                     src={process.env.REACT_APP_CONTEXT_NAME + "/image/img.png"}/>
                            </Col>
                            <Col xs='8' style={{margin: '0', padding: '8px 66px 0 0', wordBreak: 'initial'}}>
                                <p style={{margin: '0', padding: '0', fontSize: '12px'}}>Şanlıurfa Eczacı Odası</p>
                            </Col>
                        </Row>}
                    <div className="navbar-minimize">
                        <button id='sidebarModeButton' onClick={this.toggleSidebar} style={{marginTop: '10px'}}
                                className=" btn btn-simple btn-icon btn-neutral btn-round">
                            <i className="now-ui-icons text_align-center visible-on-sidebar-regular"/>
                            <i className="now-ui-icons design_bullet-list-67 visible-on-sidebar-mini"/>
                        </button>
                    </div>
                </div>

                <div
                    className="sidebar-wrapper scrollbar"
                    id="style-7"
                    style={{
                        paddingBottom: "0px",
                        display: "flex",
                        flexDirection: "column",
                        height: "calc(100vh - 65px)",
                        overflowY: "auto",
                    }}
                >

                <div className="user" style={{
                          flexShrink: 0,
                          width: "100%",
                          borderBottom: "1px solid rgba(255,255,255,0.1)",
                          paddingBottom: "10px",
                        }}
                      >
                        <div className="photo"><img src={process.env.REACT_APP_CONTEXT_NAME + "/image/avt.png"}
                                                    alt="Avatar"/></div>
                        <div className="info">
                            <a data-toggle="collapse" aria-expanded="false" href='#merdo'>
								<span>
									{this.props.currentUser.name && ((this.props.currentUser.name.length > 21) ? this.props.currentUser.name.toString().substring(0, 18) + '...' : this.props.currentUser.name) ||
                                        this.props.currentUser.email && ((this.props.currentUser.email.length > 21) ? this.props.currentUser.email.toString().substring(0, 18) + '...' : this.props.currentUser.email)}

                                    <b className="caret"/>
								</span>
                            </a>
                            <div className="collapse" id='merdo'>
                                <ul className="nav submenu">
                                <li onClick={(e) => this.onChangeSelected("member", "profil", e)}>
                                        <Link to={{pathname: '/changePasswordInner'}}>
                                            <span style={{color: this.state.activeMenu === "Profil" && "#6BD098"}}
                                                  className="sidebar-mini-icon">Ş</span>
                                            <span style={{color: this.state.activeMenu === "Profil" && "#6BD098"}}
                                                  className="sidebar-normal">Şifre Değiştir</span>
                                        </Link>
                                    </li>

                                    <li>
                                        <Link onClick={this.props.onLogout}>
                                            <span className="sidebar-mini-icon">Ç</span>
                                            <span className="sidebar-normal">Çıkış</span>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <ul className="nav">
                        <FirstLevelItem
                            name="homePage"
                            label="Ana Sayfa"
                            isActive={selected === "homePage"}
                            show={true}
                            icons="fa fa-home fa-fw"
                            sidebarItemColor="#6BD098"
                            clicked={this.onChangeSelected}/>

                        {
                            (this.RightExists("RIGHT_SELF_CREATE") && this.props.currentUser.member)
                            &&
                            <li>
                                <a data-toggle="collapse" href="#memberInfoSettings">
                                    <i className="fas fa-user"
                                       style={{color: this.state.activeMenu === "Üyelik Bilgilerim" && "#6BD098"}}/>
                                    <p style={{color: this.state.activeMenu === "Üyelik Bilgilerim" && "#6BD098"}}>Üyelik
                                        Bilgilerim<b className="caret"/></p>
                                </a>

                                <div className="collapse " id="memberInfoSettings">
                                    <ul className="nav submenu">

                                        <li className={selected === "memberInfo" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("memberInfo", "Üyelik Bilgilerim", e)}>
                                            <Link to={{pathname: '/memberInfo', cities: this.state.cities}}>
                                                <i style={{color: this.state.selected === 'memberInfo' && '#6BD098'}}
                                                   className="fas fa-plus"/>
                                                <span style={{color: this.state.selected === 'memberInfo' && '#6BD098'}}
                                                      className="sidebar-normal">Oda Kayıt/İletişim Bilgilerim</span>
                                            </Link>
                                        </li>

                                        {/*<li className={selected === "memberContactInfo" ? 'active' : ''}
											style={{"paddingLeft": "10px"}}
											onClick={(e) => this.onChangeSelected("memberContactInfo", "İletişim Bilgilerim", e)}>
											<Link to={{pathname:'/memberContactInfo', cities:this.state.cities}}   >
												<i style={{color: this.state.selected === 'memberContactInfo' && '#6BD098'}} className="fas fa-list"/>
												<span style={{color: this.state.selected === 'memberContactInfo' && '#6BD098'}}
													  className="sidebar-normal">İletişim Bilgilerim</span>
											</Link>
										</li>*/}

                                    </ul>
                                </div>
                            </li>
                        }
                        {
                            (this.RightExists("ROLE_RIGHT_SELF_READ") && this.props.currentUser.member)
                            &&
                            <li>
                                <a data-toggle="collapse" href="#announcementInfoSettings">
                                    <i className="fas fa-rss"
                                       style={{color: this.state.activeMenu === "Duyurular" && "#6BD098"}}/>
                                    <p style={{color: this.state.activeMenu === "Duyurular" && "#6BD098"}}>Duyurular<b
                                        className="caret"/></p>
                                </a>

                                <div className="collapse " id="announcementInfoSettings">
                                    <ul className="nav submenu">

                                        <li className={selected === "announcementList" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("announcementList", "Güncel Duyurular Listesi", e)}>
                                            <Link to={{pathname: '/underconstruction', cities: this.state.cities}}>
                                                <i style={{color: this.state.selected === 'announcementList' && '#6BD098'}}
                                                   className="fas fa-plus"/>
                                                <span
                                                    style={{color: this.state.selected === 'announcementList' && '#6BD098'}}
                                                    className="sidebar-normal">Güncel Duyurular Listesi</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        }
                        {/*{*/}
                        {/*    (this.RightExists("ROLE_RIGHT_SELF_READ") && this.props.currentUser.member)*/}
                        {/*    &&*/}
                        {/*    <li>*/}
                        {/*        <a data-toggle="collapse" href="#certificateInfoSettings">*/}
                        {/*            <i className="fa fa-file"*/}
                        {/*               style={{color: this.state.activeMenu === "Belge İndir" && "#6BD098"}}/>*/}
                        {/*            <p style={{color: this.state.activeMenu === "Belge İndir" && "#6BD098"}}>Belge İndİr<b*/}
                        {/*                className="caret"/></p>*/}
                        {/*        </a>*/}

                        {/*        <div className="collapse " id="certificateInfoSettings">*/}
                        {/*            <ul className="nav submenu">*/}

                        {/*                <li className={selected === "memberCertificatePage" ? 'active' : ''}*/}
                        {/*                    style={{"paddingLeft": "10px"}}*/}
                        {/*                    onClick={(e) => this.onChangeSelected("memberCertificatePage", "Belge İndir", e)}>*/}
                        {/*                    <Link to={{*/}
                        {/*                        pathname: '/memberCertificatePage',*/}
                        {/*                        currentUser: this.props.currentUser*/}
                        {/*                    }}>*/}
                        {/*                        <i style={{color: this.state.selected === 'memberCertificatePage' && '#6BD098'}}*/}
                        {/*                           className="fas fa-plus"/>*/}
                        {/*                        <span*/}
                        {/*                            style={{color: this.state.selected === 'memberCertificatePage' && '#6BD098'}}*/}
                        {/*                            className="sidebar-normal">Meslek Mensubu Kimlik Sureti </span>*/}
                        {/*                    </Link>*/}
                        {/*                </li>*/}
                        {/*            </ul>*/}
                        {/*        </div>*/}
                        {/*    </li>*/}
                        {/*}*/}
                        {
                            (this.RightExists("ROLE_RIGHT_MEMBER_READ"))
                            &&
                            <li>
                                <a data-toggle="collapse" href="#customerSettings">
                                    <i className="fas fa-users"
                                       style={{color: this.state.activeMenu === "Üye İşlemleri" && "#6BD098"}}/>
                                    <p style={{color: this.state.activeMenu === "Üye İşlemleri" && "#6BD098"}}>ÜYE
                                        İŞLEMLERİ<b className="caret"/></p>
                                </a>

                                <div className="collapse " id="customerSettings">
                                    <ul className="nav submenu">
                                        {/*<li className={selected === "member" ? 'active' : ''}
										style={{"paddingLeft": "10px"}}
										onClick={(e) => this.onChangeSelected("member", "Üye İşlemleri", e)}>
										<Link to="/member"  >
											<i style={{color: this.state.selected === 'member' && '#6BD098'}} className="fas fa-plus"/>
											<span style={{color: this.state.selected === 'member' && '#6BD098'}}
												  className="sidebar-normal">Yeni Üye Kaydı</span>
										</Link>
									</li>*/}
                                        {/*
                                        <li className={selected === "memberListReview" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("customerSettings", "Üye İşlemleri", e)}>
                                            <Link to={{pathname: '/MemberListReview', mode: 'review'}}>
                                                <i style={{color: this.state.selected === 'memberListReview' && '#6BD098'}}
                                                   className="fas fa-list"/>
                                                <span
                                                    style={{color: this.state.selected === 'memberListReview' && '#6BD098'}}
                                                    className="sidebar-normal">Başvuru Onayla</span>
                                            </Link>
                                        </li> */}
                                        {
                                            (this.RightExists("ROLE_RIGHT_MEMBER_CREATE") && this.RightExists("ROLE_RIGHT_MEMBER_UPDATE") && this.RightExists("ROLE_RIGHT_MEMBER_READ")) &&
                                            <div>
                                                <li className={selected === "memberListReview" ? 'active' : ''}
                                                    style={{"paddingLeft": "10px"}}
                                                    onClick={(e) => this.onChangeSelected("customerSettings", "Üye İşlemleri", e)}>
                                                    <Link to={{pathname: '/MemberListReview', mode: 'review'}}>
                                                        <i style={{color: this.state.selected === 'memberListReview' && '#6BD098'}}
                                                           className="fas fa-list"/>
                                                        <span
                                                            style={{color: this.state.selected === 'memberListReview' && '#6BD098'}}
                                                            className="sidebar-normal">Başvuru Onayla</span>
                                                    </Link>
                                                </li>
                                                <li className={selected === "pharmacyList" ? 'active' : ''}
                                                    style={{"paddingLeft": "10px"}}
                                                    onClick={(e) => this.onChangeSelected("customerSettings", "Üye İşlemleri", e)}>
                                                    <Link to={{pathname: '/PharmacyList', mode: 'review'}}>
                                                        <i style={{color: this.state.selected === 'pharmacyList' && '#6BD098'}}
                                                           className="fas fa-list"/>
                                                        <span
                                                            style={{color: this.state.selected === 'pharmacyList' && '#6BD098'}}
                                                            className="sidebar-normal">Eczane İşlemleri</span>
                                                    </Link>
                                                </li>


                                                <li className={selected === "memberListApproval" ? 'active' : ''}
                                                    style={{"paddingLeft": "10px"}}
                                                    onClick={(e) => this.onChangeSelected("customerSettings", "Üye İşlemleri", e)}>
                                                    <Link to={{pathname: '/MemberListApproval', mode: 'approval'}}>
                                                        <i style={{color: this.state.selected === 'memberListApproval' && '#6BD098'}}
                                                           className="fas fa-list"/>
                                                        <span
                                                            style={{color: this.state.selected === 'memberListApproval' && '#6BD098'}}
                                                            className="sidebar-normal">Üye Yönetimi</span>
                                                    </Link>
                                                </li>

                                                {/*<li className={selected === "uyeolustur" ? 'active' : ''}*/}
                                                {/*    style={{"paddingLeft": "10px"}}*/}
                                                {/*    onClick={(e) => this.onChangeSelected("customerSettings", "Üye İşlemleri", e)}>*/}
                                                {/*    <Link to={{pathname: '/uyeolustur', mode: 'approval'}}>*/}
                                                {/*        <i style={{color: this.state.selected === 'uyeolustur' && '#6BD098'}}*/}
                                                {/*           className="fas fa-list"/>*/}
                                                {/*        <span*/}
                                                {/*            style={{color: this.state.selected === 'uyeolustur' && '#6BD098'}}*/}
                                                {/*            className="sidebar-normal">Üye Oluştur</span>*/}
                                                {/*    </Link>*/}
                                                {/*</li>*/}

                                                <li className={selected === "memberWithDebit" ? 'active' : ''}
                                                    style={{"paddingLeft": "10px"}}
                                                    onClick={(e) => this.onChangeSelected("customerSettings", "Oda İlişiği Kesilmiş Borçlu Üyeler", e)}>
                                                    <Link to={{
                                                        pathname: '/PassiveMemberListWithDebit',
                                                        mode: 'approval'
                                                    }}>
                                                        <i style={{color: this.state.selected === 'memberWithDebit' && '#6BD098'}}
                                                           className="fas fa-list"/>
                                                        <span
                                                            style={{color: this.state.selected === 'memberWithDebit' && '#6BD098'}}
                                                            className="sidebar-normal">İlişiği Kesilmiş Borçlu Üyeler </span>
                                                    </Link>
                                                </li>

                                                {/* <li
                                        className={selected === "memberListTransfer" ? 'active' : ''}
                                        style={{"paddingLeft": "10px"}}
                                        onClick={(e) => this.onChangeSelected("memberListTransfer", "Üye İşlemleri", e)}
                                        >
                                            <Link to={{pathname: '/MemberListTransfer', mode: 'approval'}}>
                                                <i style={{color: this.state.selected === 'memberListTransfer' && '#6BD098'}}
                                                   className="fas fa-list"/>
                                                <span
                                                    style={{color: this.state.selected === 'memberListTransfer' && '#6BD098'}}
                                                    className="sidebar-normal">Transfer Kabul</span>
                                            </Link>
                                        </li>*/}

                                                {/*<li className={selected === "changeRequestList" ? 'active' : ''}*/}
                                                {/*    style={{"paddingLeft": "10px"}}*/}
                                                {/*    onClick={(e) => this.onChangeSelected("customerSettings", "Üye İşlemleri", e)}>*/}
                                                {/*    <Link to={{pathname: '/changeRequestList', mode: 'approval'}}>*/}
                                                {/*        <i style={{color: this.state.selected === 'changeRequestList' && '#6BD098'}}*/}
                                                {/*           className="fas fa-list"/>*/}
                                                {/*        <span*/}
                                                {/*            style={{color: this.state.selected === 'changeRequestList' && '#6BD098'}}*/}
                                                {/*            className="sidebar-normal">Üye İstek Ve Talepleri</span>*/}
                                                {/*    </Link>*/}
                                                {/*</li>*/}
                                            </div>
                                        }

                                        {/*<li className={selected === "createMember" ? 'active' : ''}*/}
                                        {/*    style={{"paddingLeft": "10px"}}*/}
                                        {/*    onClick={(e) => this.onChangeSelected("customerSettings", "Üye İşlemleri", e)}>*/}
                                        {/*    <Link to={{pathname: '/newMember', mode: 'review'}}>*/}

                                        {/*        <i style={{color: this.state.selected === 'createMember' && '#6BD098'}}*/}
                                        {/*           className="fas fa-list"/>*/}
                                        {/*        <span*/}
                                        {/*            style={{color: this.state.selected === 'createMember' && '#6BD098'}}*/}
                                        {/*            className="sidebar-normal">Üye Kaydı Oluştur</span>*/}
                                        {/*    </Link>*/}
                                        {/*</li>*/}


                                        {/*{*/}
                                        {/*    (this.RightExists("ROLE_RIGHT_FINANCIAL_PARAMETERS_CREATE", this.props.authorities))*/}
                                        {/*    && <li className={selected === "changeRequestList" ? 'active' : ''}*/}
                                        {/*           style={{"paddingLeft": "10px"}}*/}
                                        {/*           onClick={(e) => this.onChangeSelected("customerSettings", "Mail Logları", e)}>*/}
                                        {/*        <Link to={{pathname: '/mailLogs'}}>*/}
                                        {/*            <i style={{color: this.state.selected === 'mailLogs' && '#6BD098'}}*/}
                                        {/*               className="fas fa-list"/>*/}
                                        {/*            <span*/}
                                        {/*                style={{color: this.state.selected === 'mailLogs' && '#6BD098'}}*/}
                                        {/*                className="sidebar-normal">Mail Logları</span>*/}
                                        {/*        </Link>*/}
                                        {/*    </li>*/}
                                        {/*}*/}
                                    </ul>
                                </div>
                            </li>
    }

                        {/*{*/}
                        {/*    (this.RightExists("ROLE_RIGHT_BRANCH_READ"))*/}
                        {/*    &&*/}
                        {/*    <li>*/}
                        {/*        <a data-toggle="collapse" href="#odaSettings"*/}
                        {/*           onClick={() => this.onChangeSelected('odaSettings')}*/}
                        {/*        >*/}
                        {/*            <i className="fas fa-university"*/}
                        {/*               style={{color: this.state.activeMenu === "Oda İşlemleri" && "#6BD098"}}/>*/}
                        {/*            <p style={{color: this.state.activeMenu === "Oda İşlemleri" && "#6BD098"}}>PORTAL YÖNETİMİ<b className="caret"/></p>*/}
                        {/*        </a>*/}

                        {/*        <div className={this.state.activeMenu === 'odaSettings' ? 'collapse show' : 'collapse'}*/}
                        {/*             id="odaSettings">*/}
                        {/*            <ul className="nav submenu">*/}
                        {/*                <li className={selected === "odaList" ? 'active' : ''}*/}
                        {/*                    style={{"paddingLeft": "10px"}}*/}
                        {/*                    onClick={(e) => this.onChangeSelected("portalYonetimi", "Haber - Duyuru gonder", e)}>*/}
                        {/*                    <Link to="/sendNewsAnnouncement">*/}
                        {/*                        <i style={{color: this.state.selected === 'odaList' && '#6BD098'}}*/}
                        {/*                           className="fas fa-list"/>*/}
                        {/*                        <span style={{color: this.state.selected === 'odaList' && '#6BD098'}}*/}
                        {/*                              className="sidebar-normal">Haber - Duyuru gönder</span>*/}
                        {/*                    </Link>*/}
                        {/*                </li>*/}
                        {/*                <li className={selected === "commissionMeeting" ? 'active' : ''}*/}
                        {/*                    style={{"paddingLeft": "10px"}}*/}
                        {/*                    onClick={(e) => this.onChangeSelected("portalYonetimi", "Nobetci Eczane Gonder", e)}>*/}
                        {/*                    <Link to="/nobetciEczaneGonder">*/}
                        {/*                        <i style={{color: this.state.selected === 'commissionMeeting' && '#6BD098'}}*/}
                        {/*                           className="fas fa-list"/>*/}
                        {/*                        <span*/}
                        {/*                            style={{color: this.state.selected === 'commissionMeeting' && '#6BD098'}}*/}
                        {/*                            className="sidebar-normal">Nöbetçi Eczane Gönder</span>*/}
                        {/*                    </Link>*/}
                        {/*                </li>*/}
                        {/*            </ul>*/}
                        {/*        </div>*/}
                        {/*    </li>*/}
                        {/*}*/}

                        {
                            (this.RightExists("ROLE_RIGHT_BRANCH_READ"))
                            &&
                            <li>
                                <a data-toggle="collapse" href="#odaSettings">
                                    <i className="fas fa-university"
                                       style={{color: this.state.activeMenu === "Oda İşlemleri" && "#6BD098"}}/>
                                    <p style={{color: this.state.activeMenu === "Oda İşlemleri" && "#6BD098"}}>Komisyon
                                        İŞLEMLERİ<b className="caret"/></p>
                                </a>

                                <div className="collapse " id="odaSettings">
                                    <ul className="nav submenu">
                                        <li className={selected === "odaList" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("odaSettings", "Oda İşlemleri", e)}>
                                            <Link to="/underconstruction">
                                                <i style={{color: this.state.selected === 'odaList' && '#6BD098'}}
                                                   className="fas fa-list"/>
                                                <span style={{color: this.state.selected === 'odaList' && '#6BD098'}}
                                                      className="sidebar-normal">Komisyon Listesi</span>
                                            </Link>
                                        </li>
                                        {/* "Belge İşlemleri" bölümünü yorum satırına alıyoruz */}
                                        {/* <li className={selected === "opCertificate" ? 'active' : ''}
            style={{"paddingLeft": "10px"}}
            onClick={(e) => this.onChangeSelected("odaSettings", "Oda İşlemleri", e)}>
            <Link to="/opCertificate">
                <i style={{color: this.state.selected === 'opCertificate' && '#6BD098'}}
                   className="fas fa-list"/>
                <span
                    style={{color: this.state.selected === 'opCertificate' && '#6BD098'}}
                    className="sidebar-normal">Belge İşlemleri</span>
            </Link>
        </li> */}

                                        <li className={selected === "commissionMeeting" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("odaSettings", "Komisyon Toplantı ve Planlama", e)}>
                                            <Link to="/underconstruction">
                                                <i style={{color: this.state.selected === 'commissionMeeting' && '#6BD098'}}
                                                   className="fas fa-list"/>
                                                <span
                                                    style={{color: this.state.selected === 'commissionMeeting' && '#6BD098'}}
                                                    className="sidebar-normal">Toplantı Planı Ve Yönetimi</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>

                            </li>
                        }
                        {
                            (this.RightExists("ROLE_RIGHT_DOCUMENT_WORK"))
                            &&
                            <li>
                                <a data-toggle="collapse" href="#paperSettings"
                                   onClick={() => this.onChangeSelected('paperSettings')}
                                >
                                    <i className="fas fa-book"
                                       style={{color: this.state.activeMenu === "Oda İşlemleri" && "#6BD098"}}/>
                                    <p style={{color: this.state.activeMenu === "Oda İşlemleri" && "#6BD098"}}>EVRAK
                                        İŞLEMLERİ<b className="caret"/></p>
                                </a>

                                <div
                                    className={this.state.activeMenu === 'paperSettings' ? 'collapse show' : 'collapse'}
                                    id="paperSettings">
                                    <ul className="nav submenu">
                                        <li className={selected === "paperWork" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("paperSettings", "Evrak İşlemleri", e)}>
                                            <Link to="/underconstruction">
                                                <i style={{color: this.state.selected === 'paperWork' && '#6BD098'}}
                                                   className="fas fa-list"/>
                                                <span
                                                    style={{color: this.state.selected === 'paperWork' && '#6BD098'}}
                                                    className="sidebar-normal">Belge Yönetimi</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        }
                        {
                            (this.RightExists("ROLE_RIGHT_MEMBER_CREATE"))
                            &&
                            <li>
                                <a data-toggle="collapse" href="#userSettings">
                                    <i className="fas fa-user"
                                       style={{color: this.state.activeMenu === "Kullanıcı İşlemleri" && "#6BD098"}}/>
                                    <p style={{color: this.state.activeMenu === "Kullanıcı İşlemleri" && "#6BD098"}}>Kullanıcı
                                        İŞLEMLERİ<b className="caret"/></p>
                                </a>
                                <div className={this.state.activeMenu === 'userSettings' ? 'collapse show' : 'collapse'}
                                     id="userSettings">
                                    <ul className="nav submenu">
                                        <li className={selected === "odaList" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("userSettings", "Kullanıcı İşlemleri", e)}>
                                            <Link to="/underconstruction">
                                                <i style={{color: this.state.selected === 'userList' && '#6BD098'}}
                                                   className="fas fa-list"/>
                                                <span style={{color: this.state.selected === 'userList' && '#6BD098'}}
                                                      className="sidebar-normal">Kullanıcı Düzenle</span>
                                            </Link>
                                        </li>
                                        <li className={selected === "userGuide" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("userSettings", "Kullanıcı İşlemleri", e)}>
                                            <Link to="/underconstruction">
                                                <i style={{color: this.state.selected === 'userGuide' && '#6BD098'}}
                                                   className="fas fa-list"/>
                                                <span style={{color: this.state.selected === 'userGuide' && '#6BD098'}}
                                                      className="sidebar-normal">Portal Kullanım Kılavuzu</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        }

                        {
                            (this.RightExists("ROLE_RIGHT_ANNOUNCEMENT_READ"))
                            &&
                            <li>
                                <a data-toggle="collapse" href="#announcementSettings">
                                    <i className="fas fa-rss"
                                       style={{color: this.state.activeMenu === "Duyuru İşlemleri" && "#6BD098"}}/>
                                    <p style={{color: this.state.activeMenu === "Duyuru İşlemleri" && "#6BD098"}}>Duyuru
                                        Ve Anket <b className="caret"/></p>
                                </a>

                                <div className="collapse " id="announcementSettings">
                                    <ul className="nav submenu">

                                        {
                                            (this.RightExists("ROLE_RIGHT_ANNOUNCEMENT_CREATE"))
                                            &&
                                            <li className={selected === "announcementList" ? 'active' : ''}
                                                style={{"paddingLeft": "10px"}}
                                                onClick={(e) => this.onChangeSelected("announcementSettings", "Duyuru İşlemleri", e)}>
                                                <Link to="/announcementList">
                                                    <i style={{color: this.state.selected === 'announcementList' && '#6BD098'}}
                                                       className="fas fa-list"/>
                                                    <span
                                                        style={{color: this.state.selected === 'announcementList' && '#6BD098'}}
                                                        className="sidebar-normal">Duyuru Yönetimi</span>
                                                </Link>
                                            </li>
                                        }
                                        <li className={selected === "announcementMainPage" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("announcementSettings", "Duyuru İşlemleri", e)}>
                                            <Link to="/underconstruction">
                                                <i style={{color: this.state.selected === 'announcementMainPage' && '#6BD098'}}
                                                   className="fas fa-list"/>
                                                <span
                                                    style={{color: this.state.selected === 'announcementMainPage' && '#6BD098'}}
                                                    className="sidebar-normal">Güncel Duyurular Listesi</span>
                                            </Link>
                                        </li>

                                        <li className={selected === "balance" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("anlasmalar", "Anlaşmalar", e)}>
                                            <Link to="/anlasmalar">
                                                <i style={{color: this.state.selected === 'anlasmalar' && '#6BD098'}}
                                                   className="fas fa-list"/>
                                                <span style={{color: this.state.selected === 'anlasmalar' && '#6BD098'}}
                                                      className="sidebar-normal">Anlaşma Yönetimi</span>
                                            </Link>
                                        </li>

                                        <li className={selected === "balance" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("isilani", "İş İlanları", e)}>
                                            <Link to="/isilanlari">
                                                <i style={{color: this.state.selected === 'is' && '#6BD098'}}
                                                   className="fas fa-list"/>
                                                <span style={{color: this.state.selected === 'is' && '#6BD098'}}
                                                      className="sidebar-normal">İlanlar</span>
                                            </Link>
                                        </li>
                                        {/*<li className={selected === "balance" ? 'active' : ''}*/}
                                        {/*    style={{"paddingLeft": "10px"}}*/}
                                        {/*    onClick={(e) => this.onChangeSelected("anketIslem", "Oluşturduğum Anketler", e)}>*/}
                                        {/*    <Link to="/anketlerim">*/}
                                        {/*        <i style={{color: this.state.selected === 'anket' && '#6BD098'}}*/}
                                        {/*           className="fas fa-list"/>*/}
                                        {/*        <span style={{color: this.state.selected === 'anket' && '#6BD098'}}*/}
                                        {/*              className="sidebar-normal">Anket İşlemleri</span>*/}
                                        {/*    </Link>*/}
                                        {/*</li>*/}
                                        {/*<li className={selected === "youtubeVideos" ? 'active' : ''}*/}
                                        {/*    style={{"paddingLeft": "10px"}}*/}
                                        {/*    onClick={(e) => this.onChangeSelected("youtubeOps", "YouTube Video Yayınlarımız", e)}>*/}
                                        {/*    <Link to="/youtubevideos">*/}
                                        {/*        <i style={{color: this.state.selected === 'youtubeVideos' && '#FF0000'}}*/}
                                        {/*           className="fas fa-list"/>*/}
                                        {/*        <span*/}
                                        {/*            style={{color: this.state.selected === 'youtubeVideos' && '#FF0000'}}*/}
                                        {/*            className="sidebar-normal">Youtube Videolarımız </span>*/}
                                        {/*    </Link>*/}
                                        {/*</li>*/}


                                    </ul>
                                </div>


                            </li>
                        }


                        {
                            (this.RightExists("ROLE_RIGHT_PAYMENT_READ"))
                            &&
                            <li>
                                <a data-toggle="collapse" href="#paymentSettings">
                                    <i className="fas fa-turkish-lira "
                                       style={{color: this.state.activeMenu === "Gelir-Gider İşlemleri" && "#6BD098"}}/>
                                    <p style={{color: this.state.activeMenu === "Gelir-Gider İşlemleri" && "#6BD098"}}>GELİR
                                        - GİDER İŞLEMLERİ<b className="caret"/></p>
                                </a>

                                <div className="collapse " id="paymentSettings">
                                    <ul className="nav submenu">
                                        <li className={selected === "balance" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("paymentSettings", "Gelir-Gider İşlemleri", e)}>
                                            <Link to="/balance">
                                                <i style={{color: this.state.selected === 'balance' && '#6BD098'}}
                                                   className="fas fa-list"/>
                                                <span style={{color: this.state.selected === 'balance' && '#6BD098'}}
                                                      className="sidebar-normal">Oda Muhasebe Yönetimi</span>
                                            </Link>
                                        </li>


                                        {/*<li className={selected === "accrualStats" ? 'active' : ''}*/}
                                        {/*    style={{"paddingLeft": "10px"}}*/}
                                        {/*    onClick={(e) => this.onChangeSelected("paymentSettings", "Gelir-Gider İşlemleri", e)}>*/}
                                        {/*    <Link to="/accrualStats">*/}
                                        {/*        <i style={{color: this.state.selected === 'accrualStats' && '#6BD098'}}*/}
                                        {/*           className="fas fa-list"/>*/}
                                        {/*        <span*/}
                                        {/*            style={{color: this.state.selected === 'accrualStats' && '#6BD098'}}*/}
                                        {/*            className="sidebar-normal">İktisadi İşletme Yönetimi</span>*/}
                                        {/*    </Link>*/}
                                        {/*</li>*/}


                                        <li className={selected === "incomeList" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("paymentSettings", "Gelir-Gider İşlemleri", e)}>
                                            <Link to="/underconstruction">
                                                <i style={{color: this.state.selected === 'incomeList' && '#6BD098'}}
                                                   className="fas fa-list"/>
                                                <span style={{color: this.state.selected === 'incomeList' && '#6BD098'}}
                                                      className="sidebar-normal">Oda Gelir Yönetimi</span>
                                            </Link>
                                        </li>

                                        <li className={selected === "paymentList" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("paymentSettings", "Gelir-Gider İşlemleri", e)}>
                                            <Link to="/underconstruction">
                                                <i style={{color: this.state.selected === 'paymentList' && '#6BD098'}}
                                                   className="fas fa-list"/>
                                                <span
                                                    style={{color: this.state.selected === 'paymentList' && '#6BD098'}}
                                                    className="sidebar-normal">Oda Gider Yönetimi</span>
                                            </Link>
                                        </li>


                                        <li className={selected === "feeList" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("paymentSettings", "Gelir-Gider İşlemleri", e)}>
                                            <Link to="/underconstruction">
                                                <i style={{color: this.state.selected === 'feeList' && '#6BD098'}}
                                                   className="fas fa-list"/>
                                                <span style={{color: this.state.selected === 'feeList' && '#6BD098'}}
                                                      className="sidebar-normal">Aidat Tahakkuk İşlemleri</span>
                                            </Link>
                                        </li>

                                        <li className={selected === "receiptList" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("paymentSettings", "Gelir-Gider İşlemleri", e)}>
                                            <Link to="/underconstruction">
                                                <i style={{color: this.state.selected === 'receiptList' && '#6BD098'}}
                                                   className="fas fa-list"/>
                                                <span
                                                    style={{color: this.state.selected === 'receiptList' && '#6BD098'}}
                                                    className="sidebar-normal">Fatura İşlemleri</span>
                                            </Link>
                                        </li>
                                        {
                                            (this.RightExists("ROLE_RIGHT_FINANCIAL_PARAMETERS_CREATE", this.props.authorities))
                                            &&
                                            <li className={selected === "financialParameters" ? 'active' : ''}
                                                style={{"paddingLeft": "10px"}}
                                                onClick={(e) => this.onChangeSelected("paymentSettings", "Gelir-Gider İşlemleri", e)}>
                                                <Link to="/financialParameters">
                                                    <i style={{color: this.state.selected === 'financialParameters' && '#6BD098'}}
                                                       className="fas fa-list"/>
                                                    <span
                                                        style={{color: this.state.selected === 'financialParameters' && '#6BD098'}}
                                                        className="sidebar-normal">Parametre Tanımları</span>
                                                </Link>
                                            </li>
                                        }
                                    </ul>
                                </div>
                            </li>
                        }
                        {
                            (!this.RightExists("ROLE_RIGHT_PAYMENT_READ") && !this.RightExists("ROLE_RIGHT_MEMBER_READ") && !this.RightExists("ROLE_RIGHT_SELF_CREATE"))
                            &&
                            <li>
                                <a data-toggle="collapse" href="#paymentSettings"
                                   onClick={() => this.onChangeSelected('paymentSettings')}
                                >
                                    <i className="fas fa-turkish-lira "
                                       style={{color: this.state.activeMenu === "Gelir-Gider İşlemleri" && "#6BD098"}}/>
                                    <p style={{color: this.state.activeMenu === "Gelir-Gider İşlemleri" && "#6BD098"}}>GELİR
                                        - GİDER İŞLEMLERİ<b className="caret"/></p>
                                </a>

                                <div
                                    className={this.state.activeMenu === 'paymentSettings' ? 'collapse show' : 'collapse'}
                                    id="paymentSettings">
                                    <ul className="nav submenu">

                                        <li className={selected === "feeList" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("paymentSettings", "Gelir-Gider İşlemleri", e)}>
                                            <Link to="/accrualListUye">
                                                <i style={{color: this.state.selected === 'feeList' && '#6BD098'}}
                                                   className="fas fa-list"/>
                                                <span style={{color: this.state.selected === 'feeList' && '#6BD098'}}
                                                      className="sidebar-normal">Aidat Tahakkuk İşlemleri</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        }
                        {
                            (this.RightExists("ROLE_RIGHT_DUTY_CREATE_UPDATE_DELETE"))
                            &&
                            <li>
                                <a data-toggle="collapse" href="#nobetciEczaneOps"
                                   onClick={() => this.onChangeSelected('nobetciEczaneOps')}
                                >
                                    <i className="fas fa-pills"
                                       style={{color: this.state.activeMenu === "Nöbet İşlemleri" && "#6BD098"}}/>
                                    <p style={{color: this.state.activeMenu === "Nöbet İşlemleri" && "#6BD098"}}>NÖBET
                                        İŞLEMLERİ<b className="caret"/></p>
                                </a>
                                <div className={ this.state.activeMenu === 'nobetciEczaneOps' ? 'collapse show' : 'collapse'}  id="nobetciEczaneOps">
                                    <ul className="nav submenu">
                                        <li className={selected === "dutyRoster" ? 'active' : ''}
                                            style={{ paddingLeft: "10px" }}
                                            onClick={(e) =>
                                                this.onChangeSelected("nobetciEczaneOps", "Nöbet İşlemleri", e)
                                            }
                                        >
                                            <Link to="/dutyRoster">
                                                <i
                                                    style={{
                                                        color: this.state.selected === 'dutyRoster' && '#6BD098',
                                                    }}
                                                    className="fas fa-list"
                                                />
                                                <span
                                                    style={{
                                                        color: this.state.selected === 'dutyRoster' && '#6BD098',
                                                    }}
                                                    className="sidebar-normal"
                                                >
            Nöbet Listesi
        </span>
                                            </Link>
                                        </li>

                                        {/*<li className={selected === "nobetciler" ? 'active' : ''}*/}
                                        {/*    style={{"paddingLeft": "10px"}}*/}
                                        {/*    onClick={(e) => this.onChangeSelected("nobetciEczaneOps", "Nöbet İşlemleri", e)}>*/}
                                        {/*    <Link to="/nobetcieczane">*/}
                                        {/*        <i style={{color: this.state.selected === 'nobetciler' && '#6BD098'}}*/}
                                        {/*           className="fas fa-list"/>*/}
                                        {/*        <span style={{color: this.state.selected === 'nobetciler' && '#6BD098'}}*/}
                                        {/*              className="sidebar-normal">Nöbetci Eczaneler</span>*/}
                                        {/*    </Link>*/}
                                        {/*</li>*/}
                                        {/*<li className={selected === "nobetciParams" ? 'active' : ''}*/}
                                        {/*    style={{"paddingLeft": "10px"}}*/}
                                        {/*    onClick={(e) => this.onChangeSelected("nobetciEczaneOps", "Nöbet İşlemleri", e)}>*/}
                                        {/*    <Link to="/nobetciParams">*/}
                                        {/*        <i style={{color: this.state.selected === 'nobetciParams' && '#6BD098'}}*/}
                                        {/*           className="fas fa-list"/>*/}
                                        {/*        <span*/}
                                        {/*            style={{color: this.state.selected === 'nobetciParams' && '#6BD098'}}*/}
                                        {/*            className="sidebar-normal">Nöbet Parametreleri</span>*/}
                                        {/*    </Link>*/}
                                        {/*</li>*/}

                                    {/*    <li className={selected === "nobetTalep" ? 'active' : ''}*/}
                                    {/*        style={{"paddingLeft": "10px"}}*/}
                                    {/*        onClick={(e) => this.onChangeSelected("nobetciEczaneOps", "Nöbet Talep İşlemleri", e)}>*/}
                                    {/*        <Link to="/nobetTalep">*/}
                                    {/*            <i style={{color: this.state.selected === 'nobetTalep' && '#6BD098'}}*/}
                                    {/*               className="fas fa-list"/>*/}
                                    {/*            <span*/}
                                    {/*                style={{color: this.state.selected === 'nobetTalep' && '#6BD098'}}*/}
                                    {/*                className="sidebar-normal">Nöbet Değişiklik Talepleri</span>*/}
                                    {/*        </Link>*/}
                                    {/*    </li>*/}

                                    </ul>
                                </div>

                            </li>
                        }
                        {/*{*/}
                        {/*    (this.RightExists("ROLE_RIGHT_PEYK_READ"))*/}
                        {/*    &&*/}
                        {/*    <li>*/}
                        {/*        <a href="https://peyk.kolaysoft.com.tr" target="_blank">*/}
                        {/*            <i className="fas fa-building"></i>*/}
                        {/*            <p>Peyk Portal</p>*/}
                        {/*        </a>*/}
                        {/*    </li>*/}
                        {/*}*/}


                        {/* {
                            <li>
                                <a data-toggle="collapse" href="#isilani"
                                   onClick={() => this.onChangeSelected('isilani')}
                                >
                                    <i className="fas fa-clipboard-list"
                                       style={{color: this.state.activeMenu === "İş İlanları" && "#6BD098"}}/>
                                    <p style={{color: this.state.activeMenu === "İş İlanları " && "#6BD098"}}>İş İlanları<b className="caret"/></p>
                                </a>
                                <div className={ this.state.activeMenu === 'isilani' ? 'collapse show' : 'collapse'}  id="isilani">
                                    <ul className="nav submenu">

                                        <li className={selected === "balance" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("isilani", "İş İlanları", e)}>
                                        <Link to="/isilanlari">
                                                <i style={{color: this.state.selected === 'is' && '#6BD098'}}
                                                   className="fas fa-list"/>
                                                <span style={{color: this.state.selected === 'is' && '#6BD098'}}
                                                      className="sidebar-normal">İş İlanları</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>


                            </li>
                        } */}

                        {/* {
                            <li>
                                <a data-toggle="collapse" href="#anlasmalar"
                                   onClick={() => this.onChangeSelected('anlasmalar')}
                                >
                                    <i className="fas fa-clipboard-list"
                                       style={{color: this.state.activeMenu === "Anlaşmalar" && "#6BD098"}}/>
                                    <p style={{color: this.state.activeMenu === "Anlaşmalar " && "#6BD098"}}>Anlaşmalar<b className="caret"/></p>
                                </a>
                                <div className={ this.state.activeMenu === 'anlasmalar' ? 'collapse show' : 'collapse'}  id="anlasmalar">
                                    <ul className="nav submenu">

                                        <li className={selected === "balance" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("anlasmalar", "Anlaşmalar", e)}>
                                        <Link to="/anlasmalar">
                                                <i style={{color: this.state.selected === 'anlasmalar' && '#6BD098'}}
                                                   className="fas fa-list"/>
                                                <span style={{color: this.state.selected === 'anlasmalar' && '#6BD098'}}
                                                      className="sidebar-normal">Anlaşma Yönetimi</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>


                            </li>
                        } */}
                        {/* {
                <div>
                    <li>
                        <a data-toggle="collapse" href="#downloadRequests"
                            onClick={() => this.onChangeSelected('downloadRequests')}
                        >
                            <i className="fas fa-calendar"
                                style={{ color: this.state.activeMenu === "İndirme Talepleriniz" && "#6BD098" }} />
                            <p style={{ color: this.state.activeMenu === "İndirme Talepleriniz" && "#6BD098" }}>
                                İndirme Talepleri<b className="caret" />
                            </p>
                        </a>

                        <div className={this.state.activeMenu === 'downloadRequests' ? 'collapse show' : 'collapse'} id="downloadRequests">
                            <ul className="nav submenu">
                                <li className={selected === "balance" ? 'active' : ''}
                                    style={{ "paddingLeft": "10px" }}
                                    onClick={(e) => { this.onChangeSelected("downloadRequests", "Ajanda İşlemleri", e); this.openDownloadRequestModal(); }}>
                                    <Link to="/">
                                        <i style={{ color: this.state.selected === 'downloadRequests' && '#6BD098' }}
                                            className="fas fa-list" />
                                        <span style={{ color: this.state.selected === 'downloadRequests' && '#6BD098' }}
                                                className="sidebar-normal">İndirme Talepleriniz </span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </li>
                    {this.state.downloadRequestModal &&
                    <DownloadRequestModal isOpen={this.state.downloadRequestModal}
                                            close={this.closeDownloadRequestModal} />}
                    </div>
                } */}


                        {
                            (this.RightExists("ROLE_RIGHT_AGENDA_CRUD"))
                            &&
                            <li>
                                <a data-toggle="collapse" href="#agendaOps"
                                   onClick={() => this.onChangeSelected('agendaOps')}

                                >
                                    <i className="fas fa-calendar"
                                       style={{color: this.state.activeMenu === "Ajanda İşlemleri" && "#6BD098"}}/>
                                    <p style={{color: this.state.activeMenu === "Ajanda İşlemleri" && "#6BD098"}}>Ajanda
                                        İŞLEMLERİ<b className="caret"/></p>
                                </a>

                                <div className={this.state.activeMenu === 'agendaOps' ? 'collapse show' : 'collapse'}
                                     id="agendaOps">
                                    <ul className="nav submenu">
                                        <li className={selected === "balance" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("agendaOps", "Ajanda İşlemleri", e)}>
                                            <Link to="/underconstruction">
                                                <i style={{color: this.state.selected === 'ajandalar' && '#6BD098'}}
                                                   className="fas fa-list"/>
                                                <span style={{color: this.state.selected === 'ajandalar' && '#6BD098'}}
                                                      className="sidebar-normal">Komisyon Takvimi</span>
                                            </Link>
                                        </li>


                                        <li className={selected === "yonetimKuruluTakvimi" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("agendaOps", "Ajanda İşlemleri", e)}>
                                            <Link to="/underconstruction">
                                                <i style={{color: this.state.selected === 'yonetimKuruluTakvimi' && '#6BD098'}}
                                                   className="fas fa-list"/>
                                                <span
                                                    style={{color: this.state.selected === 'yonetimKuruluTakvimi' && '#6BD098'}}
                                                    className="sidebar-normal">Yönetim Kurulu Takvimi</span>
                                            </Link>
                                        </li>

                                        {/*<li className={selected === "bireyselTakvimler" ? 'active' : ''}*/}
                                        {/*    style={{"paddingLeft": "10px"}}*/}
                                        {/*    onClick={(e) => this.onChangeSelected("agendaOps", "Ajanda İşlemleri", e)}>*/}
                                        {/*    <Link to="/bireyselTakvimler">*/}
                                        {/*        <i style={{color: this.state.selected === 'bireyselTakvimler' && '#6BD098'}}*/}
                                        {/*           className="fas fa-list"/>*/}
                                        {/*        <span*/}
                                        {/*            style={{color: this.state.selected === 'bireyselTakvimler' && '#6BD098'}}*/}
                                        {/*            className="sidebar-normal">Bireysel Takvimler</span>*/}
                                        {/*    </Link>*/}
                                        {/*</li>*/}

                                    </ul>



                                </div>


                            </li>
                        }
                        {this.RightExists("ROLE_RIGHT_CHAMBER_DOCS_READ") && (
                            <li>
                                <a data-toggle="collapse"
                                   href="#docDownload"
                                   onClick={() => this.onChangeSelected('docDownload')}>
                                    <i className="fas fa-download"
                                       style={{
                                           color: this.state.activeMenu === "Birlik Dökümanları" && "#6BD098",
                                       }}
                                    />
                                    <p
                                        style={{
                                            color: this.state.activeMenu === "Birlik Dökümanları" && "#6BD098",
                                        }}
                                    >
                                        BİRLİK DÖKÜMANLARI
                                        <b className="caret"/>
                                    </p>
                                </a>

                                <div className={this.state.activeMenu === 'docDownload' ? 'collapse show' : 'collapse'}
                                     id="docDownload">
                                    <ul className="nav submenu">
                                        <li
                                            className={selected === "docDownload" ? 'active' : ''}
                                            style={{paddingLeft: "10px"}}
                                            onClick={(e) => this.onChangeSelected("docDownload", "Birlik Dökümanları", e)}>
                                            <Link to="/underconstruction">
                                                <i
                                                    style={{
                                                        color: this.state.selected === "docDownload" && "#6BD098",
                                                    }}
                                                    className="fas fa-list"
                                                />
                                                <span
                                                    style={{color: this.state.selected === 'docDownload' ? '#6BD098' : undefined}}
                                                    className="sidebar-normal">Birlik Döküman Listesi</span>
                                            </Link>
                                        </li>
                                        {/*<li className={selected === "balance" ? 'active' : ''}*/}
                                        {/*    style={{paddingLeft: "10px"}}*/}
                                        {/*    onClick={(e) => {*/}
                                        {/*        this.onChangeSelected("downloadRequests", "İndirme İşlemleri", e);*/}
                                        {/*        this.openDownloadRequestModal();*/}
                                        {/*    }}>*/}
                                        {/*    <Link to="/">*/}
                                        {/*        <i style={{color: this.state.selected === 'downloadRequests' ? '#6BD098' : undefined}}*/}
                                        {/*           className="fas fa-list"/>*/}
                                        {/*        <span*/}
                                        {/*            style={{color: this.state.selected === 'downloadRequests' ? '#6BD098' : undefined}}*/}
                                        {/*            className="sidebar-normal">İndirme Talepleriniz</span>*/}
                                        {/*    </Link>*/}
                                        {/*</li>*/}
                                    </ul>
                                </div>
                            </li>
                        )}
                        {this.state.downloadRequestModal &&
                            <DownloadRequestModal isOpen={this.state.downloadRequestModal}
                                                  close={this.closeDownloadRequestModal}/>}





                    </ul>

                    <ul className="nav submenu" style={{width: "100%", marginTop: "auto"}}>
                        <li

                            // onClick={this.props.onLogout}
                            onClick={this.showModal}
                            style={{
                                fontFamily: "Muli, Helvetica, Arial, sans-serif",
                                color: "white",
                                fontSize: "14px",
                                textAlign: "center",
                                background: "#ef767d",
                                padding: "11px 0",
                                cursor: "pointer"
                            }}>
                            ÇIKIŞ
                        </li>
                    </ul>
                    <Modal
                        title="Onay"
                        visible={this.state.visible}
                        okText="Çıkış"
                        cancelText="Vazgeç"
                        onOk={this.props.onLogout}
                        onCancel={this.handleCancel}
                        maskClosable={false}
                    >
                        <p><h4>Çıkmak istediğinizden emin misiniz?</h4></p>

                    </Modal>
                </div>
            </div>
        );
    }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/layout/Sidebar.js